module.exports = __webpack_public_path__ + "278d03beebd455dc798221be999420bc.MP3";